import React from 'react';
import { MessageSquare, ClipboardCheck, CalendarDays, FileSpreadsheet, Cpu, Presentation } from 'lucide-react';
const bonuses = [{
  icon: MessageSquare,
  title: '100 Dibattiti Guidati',
  desc: 'Spunti e tracce per stimolare il pensiero critico in classe.'
}, {
  icon: ClipboardCheck,
  title: '50 Compiti di Realtà',
  desc: 'Progetti pratici per valutare le competenze civiche.'
}, {
  icon: CalendarDays,
  title: 'Programmazione Annuale Completa',
  desc: 'Documenti già pronti da consegnare in segreteria.'
}, {
  icon: FileSpreadsheet,
  title: 'Verifiche e Rubriche Pronte',
  desc: 'Test a risposta multipla, aperta e griglie di valutazione.'
}, {
  icon: Cpu,
  title: 'Kit IA e Cittadinanza Digitale',
  desc: "Materiali speciali sull'uso etico dell'intelligenza artificiale."
}, {
  icon: Presentation,
  title: 'Presentazioni Modificabili per la LIM',
  desc: 'Slide ad alto impatto visivo pronte da proiettare.'
}];
export function BonusSection() {
  return <section className="w-full bg-bg-dark py-24 px-4" data-id="element-10">
      <div className="max-w-5xl mx-auto" data-id="element-11">
        <div className="text-center mb-16" data-id="element-12">
          <div className="inline-flex items-center justify-center gap-2 bg-secondary/10 text-secondary border border-secondary/20 px-4 py-2 rounded-full font-bold text-sm mb-6" data-id="element-13">
            <span data-id="element-14">🎁</span> VALORE AGGIUNTO
          </div>
          <h2 className="text-3xl sm:text-5xl font-black text-text-main tracking-tight" data-id="element-15">
            6 Bonus Esclusivi Inclusi
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6" data-id="element-16">
          {bonuses.map((bonus, i) => {
          const Icon = bonus.icon;
          return <div key={i} className="bg-white rounded-2xl border border-border-light p-6 flex items-start gap-5 hover:border-primary/30 hover:shadow-md transition-all group" data-id="element-17">
                <div className="w-12 h-12 rounded-xl bg-primary/5 border border-primary/10 flex items-center justify-center flex-shrink-0 group-hover:bg-primary group-hover:text-white transition-colors" data-id="element-18">
                  <Icon className="w-6 h-6 text-primary group-hover:text-white transition-colors" data-id="element-19" />
                </div>

                <div className="flex-1" data-id="element-20">
                  <h4 className="text-text-main font-bold text-lg mb-1" data-id="element-21">
                    {bonus.title}
                  </h4>
                  <p className="text-text-sec text-sm sm:text-base leading-relaxed" data-id="element-22">
                    {bonus.desc}
                  </p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}